export type FreqPoint = {
  ts_ms: number;
  hz: number;
  source: string | null;
};

export type RawQueryRows = {
  columns: string[];
  rows: unknown[][];
};

export type SampleSecond = {
  ts_ms: number;
  rows: number;
  chargers: number;
  measurement_min: number;
  measurement_max: number;
  baseline_filled: number;
};

export type FreqView = {
  table: string;
  latest_ts_ms?: number;
  latest_hz?: number | null;
  source?: string | null;
  rows?: number;
  window_s?: number;
  median_interval_ms?: number | null;
  gaps?: number;
  gap_over_ms?: number;
  age_ms?: number | null;
  recent?: FreqPoint[];
  raw?: RawQueryRows;
  error?: string | null;
};

export type SampleView = {
  table: string;
  latest_ts_ms?: number | null;
  seconds_with_rows?: number;
  span_s?: number;
  missing_seconds?: number;
  missing_ts_ms?: number[];
  chargers_min?: number | null;
  chargers_max?: number | null;
  duplicate_seconds?: number;
  measurement_min?: number | null;
  measurement_max?: number | null;
  baseline_filled?: number;
  age_ms?: number | null;
  seconds?: SampleSecond[];
  raw_non_null?: RawQueryRows;
  raw_power?: RawQueryRows;
  error?: string | null;
};

export type QuestDbView = {
  read_at_ms: number;
  url: string;
  freq: FreqView | null;
  samples: SampleView | null;
};

export async function fetchQuestDbView(): Promise<QuestDbView> {
  const res = await fetch("/api/questdb/view", { credentials: "same-origin" });
  const data = (await res.json().catch(() => ({}))) as QuestDbView & { error?: string };
  if (!res.ok) {
    throw new Error(data.error || `QuestDB view ${res.status}`);
  }
  return data;
}
